import { createContext } from "react";
const LatestNewsContext = createContext({});
export default LatestNewsContext;
